import ModalController from "./modal_controller"
import Rails from "@rails/ujs"

export default class extends ModalController {
  static values = {
    appliedInProgressMsg: String,
    notAppliedMsg: String,
    appliedMsg: String,
  }

  apply_products_limit_yes(event) {
    super.hide(event)
    this.submit_products_limit('yes')
  }

  apply_products_limit_no(event) {
    super.hide(event)
    this.submit_products_limit('no')
  }

  submit_products_limit(applyUpdate) {
    if (applyUpdate === 'yes') {
      window.dispatchEvent(new CustomEvent("update-message", { detail: { message: this.appliedInProgressMsgValue } }))
    }
    Rails.ajax({
      type: 'post',
      url: "/products/apply_limit.json",
      data: new URLSearchParams({ apply_update: applyUpdate }),
      dataType: "json",
      success: () => {
        if (applyUpdate === 'yes') {
          window.dispatchEvent(new CustomEvent("update-message", { detail: { message: this.appliedMsgValue } }))
        } else {
          window.dispatchEvent(new CustomEvent("update-message", { detail: { message: this.notAppliedMsgValue } }))
        }
      },
      error: (result) => {
        if (result.message) {
          window.dispatchEvent(new CustomEvent("update-message", { detail: { message: result.message } }))
        }
      }
    })
  }
}
